import React from 'react';
import PropTypes from 'prop-types';
import styles from './alphabeticalFilter.module.less';

const AlphabeticalFilter = ({ 
  selectedLetter = 'A', 
  onLetterClick, 
  className = '',
  showHash = true 
}) => {
  const letters = Array.from('ABCDEFGHIJKLMNOPQRSTUVWXYZ');
  
  const handleLetterClick = (letter) => {
    if (onLetterClick) {
      onLetterClick(letter);
    }
  };

  return (
    <div className={`${styles.alphabeticalFilter} ${className}`}>
      <div className={styles.filterContainer}>
        {letters.map((letter) => (
          <span
            key={letter}
            className={`${styles.letter} ${
              selectedLetter === letter ? styles.active : ""
            }`}
            onClick={() => handleLetterClick(letter)}
          >
            {letter}
          </span>
        ))}
        {showHash && (
          <span
            className={`${styles.letter} ${styles.hash}`}
            onClick={() => handleLetterClick("#")}
          >
            #
          </span>
        )}
      </div>
    </div>
  );
};

AlphabeticalFilter.propTypes = {
  selectedLetter: PropTypes.string,
  onLetterClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  showHash: PropTypes.bool
};

AlphabeticalFilter.defaultProps = {
  selectedLetter: 'A',
  showHash: true
};

export default AlphabeticalFilter;
